import { Navigation } from "lucide-react";
import { useSettings } from "../lib/settings";

export function ShopMap({ className = "" }) {
  const { settings } = useSettings();
  const q = (settings.map_query || "").trim();
  if (!q) return null;
  const enc = encodeURIComponent(q);
  return (
    <div data-testid="shop-map" className={`relative rounded-2xl overflow-hidden border border-border bg-muted ${className}`}>
      <iframe
        title={`${settings.company_name} location`}
        src={`https://www.google.com/maps?q=${enc}&z=16&output=embed`}
        className="w-full h-full min-h-[320px] border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        data-testid="shop-map-iframe"
      />
      <a
        href={`https://www.google.com/maps/dir/?api=1&destination=${enc}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="get-directions-btn"
        className="absolute bottom-4 left-4 inline-flex items-center gap-2 bg-secondary text-white hover:bg-primary transition-colors font-medium rounded-full px-5 py-2.5 text-sm shadow-lg"
      >
        <Navigation className="w-4 h-4" strokeWidth={2} /> Get directions
      </a>
    </div>
  );
}
